/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountShortInfo} from '../models/AccountShortInfo';
import type {Error} from '../models/Error';

export interface GetUserPrimaryAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserPrimaryAccountRequest = createAction<PayloadData<void>>('ACCOUNT_OPERATIONS__GET_USER_PRIMARY_ACCOUNT__REQUEST');
export const getUserPrimaryAccountSuccess = createAction<PayloadData<AccountShortInfo>>('ACCOUNT_OPERATIONS__GET_USER_PRIMARY_ACCOUNT__SUCCESS');
export const getUserPrimaryAccountFailure = createAction<PayloadData<Error, void, true>>('ACCOUNT_OPERATIONS__GET_USER_PRIMARY_ACCOUNT__FAILURE');

export const getUserPrimaryAccountActions = [
    getUserPrimaryAccountRequest,
    getUserPrimaryAccountSuccess,
    getUserPrimaryAccountFailure
] as const;

/**
 * Get primary account for the current user. 
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserPrimaryAccount = (config?: GetUserPrimaryAccount$Config) => {
    return {
        CALL_API: {
            types: getUserPrimaryAccountActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/user-primary`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

